const HOSTNAME_TO_LOCALE = {
  'fr.getapp.be': 'fr-BE',
  'fr.getapp.ca': 'fr-CA',
  'www.getapp.ae': 'en-AE',
  'www.getapp.at': 'de-AT',
  'www.getapp.be': 'nl-BE',
  'www.getapp.ca': 'en-CA',
  'www.getapp.cl': 'es-CL',
  'www.getapp.co.nz': 'en-NZ',
  'www.getapp.co.uk': 'en-GB',
  'www.getapp.com': 'en',
  'www.getapp.com.au': 'en-AU',
  'www.getapp.com.br': 'pt',
  'www.getapp.com.co': 'es-CO',
  'www.getapp.com.mx': 'es-MX',
  'www.getapp.de': 'de',
  'www.getapp.es': 'es',
  'www.getapp.fr': 'fr',
  'www.getapp.ie': 'en-IE',
  'www.getapp.it': 'it',
  'www.getapp.nl': 'nl',
  'www.getapp.pt': 'pt-PT',
  'www.getapp.sg': 'en-SG',
  'www.getapp.za.com': 'en-ZA',
}

const STAGING_HOSTNAME_TO_LOCALE = {
  'getapp.gadev.aws.gartner.com': 'en',
  'getapp.gaqa.aws.gartner.com': 'en',
  localhost: 'en',
  '127.0.0.1': 'en',
}

const STAGING_LOCALE_SLUG_TO_LOCALE = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  nl: 'nl',
}

const getLocaleForStagingHostname = hostname => {
  if (STAGING_HOSTNAME_TO_LOCALE[hostname]) {
    return STAGING_HOSTNAME_TO_LOCALE[hostname]
  }

  if (/^pr\d+\.gappdev\.com$/i.test(hostname)) {
    return 'en'
  }

  if (/\.vercel\.app$/i.test(hostname)) {
    return 'en'
  }

  const stagingLocaleMatch = hostname.match(/^www-getapp-([a-z]{2})\.ls\./i)

  if (!stagingLocaleMatch) {
    return null
  }

  return STAGING_LOCALE_SLUG_TO_LOCALE[stagingLocaleMatch[1].toLowerCase()] || null
}

const normalizeAlternateUrl = url => {
  if (!url) {
    return null
  }

  try {
    const parsedUrl = new URL(url)
    return `${parsedUrl.origin}${parsedUrl.pathname}`.replace(/\/+$/, '') || parsedUrl.origin
  } catch {
    return String(url).replace(/\/+$/, '')
  }
}

export const getLocaleForCanonicalUrl = canonicalUrl => {
  if (!canonicalUrl) {
    return null
  }

  try {
    const { hostname } = new URL(canonicalUrl)
    return HOSTNAME_TO_LOCALE[hostname] || getLocaleForStagingHostname(hostname)
  } catch {
    return null
  }
}

export const withSelfReferencingHreflang = (hreflangs = [], canonicalUrl = '') => {
  const normalizedHreflangs = Array.isArray(hreflangs) ? hreflangs : []

  if (!normalizedHreflangs.length || !canonicalUrl) {
    return normalizedHreflangs
  }

  const locale = getLocaleForCanonicalUrl(canonicalUrl)

  if (!locale) {
    return normalizedHreflangs
  }

  const normalizedCanonicalUrl = normalizeAlternateUrl(canonicalUrl)
  const alreadyIncludesSelf = normalizedHreflangs.some(
    hreflang => hreflang?.locale === locale || normalizeAlternateUrl(hreflang?.link) === normalizedCanonicalUrl
  )

  if (alreadyIncludesSelf) {
    return normalizedHreflangs
  }

  return [{ locale, link: canonicalUrl }, ...normalizedHreflangs]
}
